<template>
  <div id="app">
    <div v-if="shouldShowNav">
      <component :is="navComponent" />
    </div>

    <div class="routerContent">
      <router-view :isDesktop="isDesktop" />
    </div>

    <BottomColumnPage v-if="isDesktop" />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import TopNav from '@/components/TopNav/TopNav.vue';
import MobileTopNav from '@/components/TopNav/mobileTopNav.vue';
import BottomColumnPage from '@/components/BottomColumnPage/index.vue';

import { useResponsive } from '@/composables/useResponsive';

// const route = useRoute()
const { isDesktop, deviceType } = useResponsive();

// const isDesktop = ref(window.innerWidth >= 1024);
const route = useRoute();

const navRejections = ['/login', '/welcome', '/QuotationList*', '/404'];

const navComponent = computed(() => (isDesktop.value ? TopNav : MobileTopNav));

const shouldShowNav = computed(() => {
  return !navRejections.some((rejectionPath) => {
    if (rejectionPath.includes('*')) {
      return route.path.startsWith(rejectionPath.split('*')[0]);
    }
    return route.path === rejectionPath;
  });
});

const handleResize = () => {
  isDesktop.value = window.innerWidth >= 1024;
};

onMounted(() => {
  console.log(process.env.NODE_ENV);
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style lang="less">
* {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
}
html {
  font-size: 4vw;
}
.routerContent {
  min-height: 100vh;
}
</style>
